"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePrevious = void 0;
var _react = require("react");
/**
 * A hook to handle storing the previous value of anything.
 * @param value - The value to watch.
 * @param setInitial - Whether it should initialise with the current value.
 * @return The previous value.
 */
const usePrevious = function (value) {
  let setInitial = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  const ref = (0, _react.useRef)(setInitial ? value : undefined);
  (0, _react.useEffect)(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
};
exports.usePrevious = usePrevious;